<template>
  <v-app>
    <v-app-bar app flat color="white">
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="grey lighten-4 pt-14">
      <div class="container1400 pb-16">
        <v-skeleton-loader
          v-if="loading"
          type="article"
          class="mt-10"
        ></v-skeleton-loader>
        <v-container fluid v-if="!loading">
          <div class="mt-6">
            <v-alert dense outlined type="error" v-if="error">
              <ul>
                <li v-for="item in error" :key="item.msg">
                  {{ $t(item.msg) }}
                </li>
              </ul>
            </v-alert>
            <div v-if="list">
              <CancellationDetailsComponent
                v-if="list.cancel_booking_id"
                :cancel_booking_id="list.cancel_booking_id"
              />
              <v-alert
                class="mb-0"
                prominent
                dense
                type="error"
                v-if="!user.isIdVerified"
              >
                <v-row align="center" no-gutters>
                  <v-col class="grow">{{ $t("Cmsg35") }} </v-col>
                  <v-col class="shrink">
                    <v-btn to="/dashboard/confirm-identity">{{
                      $t("Takeaction")
                    }}</v-btn>
                  </v-col>
                </v-row>
              </v-alert>
              <div v-if="list.property_id">
                <v-row>
                  <v-col class="auto text-right">
                    <v-btn
                      v-if="
                        list.booking_status == 'bs1' ||
                          list.booking_status == 'bs2'
                      "
                      color="red"
                      dark
                      :to="{
                        name: 'CancelBookingRequest',
                        params: { id: list._id }
                      }"
                    >
                      {{ $t("CancelTrip") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-card height="100%" elevation="0" class="mt-3 pa-5">
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-sheet
                        class="mb-3"
                        color="blue"
                        height="240"
                        v-if="!list.property_id.pictures"
                      >
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center"
                        >
                          <div class="display-3">NO Images</div>
                        </v-row>
                      </v-sheet>
                      <v-carousel
                        hide-delimiters
                        class="mb-3 pr-md-9 mx-auto"
                        height="240"
                      >
                        <v-carousel-item
                          v-for="(item, i) in list.property_id.pictures"
                          :key="i"
                          :src="
                            $store.state.baseUrl +
                              'listing/thumb320x240-' +
                              item.file_name
                          "
                        >
                        </v-carousel-item>
                      </v-carousel>
                    </v-col>
                    <v-col md="8" cols="12">
                      <h1 class="text-h6 font-weight-medium">
                        {{ $t("TripTo") }} {{ list.property_id.name }}
                      </h1>
                      <div class="pb-5 text-capitalize">
                        <span>
                          <v-icon small class="gray--text"
                            >mdi-map-marker-radius</v-icon
                          >
                          {{ list.property_id.location }}
                        </span>
                      </div>
                      <v-row>
                        <v-col cols="4">
                          <div class="overline grey--text">
                            {{ $t("TripStatus") }}
                          </div>
                          <div class="subtitle-2 pb-3">
                            {{ $t(list.booking_status) }}
                          </div>
                          <div class="overline grey--text">
                            {{ $t("Checkin") }}
                          </div>
                          <div class="subtitle-2">
                            {{
                              format(
                                new Date(
                                  list.booking_details.dates[0] + "T00:00"
                                ),
                                "eee, do MMM, yyyy"
                              )
                            }}
                            - {{ list.booking_details.check_in_time }}
                          </div>
                          <div class="overline grey--text pt-3">
                            {{ $t("Guestsdetails") }}
                          </div>
                          <div class="subtitle-2">
                            <span v-if="list.guest_details.no_adults >= 1">
                              <span
                                class=""
                                v-if="list.guest_details.no_adults == 1"
                              >
                                {{ $tc("Adult", 1) }}</span
                              >
                              <span
                                class=""
                                v-if="list.guest_details.no_adults > 1"
                              >
                                {{ $tc("Adult", 2) }}</span
                              >
                              :
                              {{ list.guest_details.no_adults }}
                            </span>
                            <span v-if="list.guest_details.no_childrens >= 1">
                              ,
                              <span
                                class="ml-2"
                                v-if="list.guest_details.no_childrens == 1"
                              >
                                {{ $tc("Children", 1) }}</span
                              >
                              <span
                                class="ml-2"
                                v-if="list.guest_details.no_childrens > 1"
                              >
                                {{ $tc("Children", 2) }}</span
                              >
                              :
                              {{ list.guest_details.no_childrens }}
                            </span>
                          </div>
                          <div v-if="list.contract_url" class="subtitle-2 py-3">
                            <a
                              target="_blank"
                              :href="$store.state.serverUrl + list.contract_url"
                              @click.stop
                            >
                              {{ $t("REA") }}
                            </a>
                          </div>
                        </v-col>
                        <v-col cols="4">
                          <div class="overline grey--text">
                            {{ $t("Tripid") }}
                          </div>
                          <div class="subtitle-2 pb-3">
                            {{ list._id }}
                          </div>
                          <div class="overline grey--text">
                            {{ $t("Checkout") }}
                          </div>
                          <div class="subtitle-2">
                            {{
                              format(
                                new Date(
                                  list.booking_details.dates[1] + "T00:00"
                                ),
                                "eee, do MMM, yyyy"
                              )
                            }}
                            - {{ list.booking_details.check_out_time }}
                          </div>
                        </v-col>
                        <v-col cols="4">
                          <div class="overline grey--text">
                            {{ $t("BookedFor") }}
                          </div>
                          <div class="subtitle-2">
                            {{ list.booking_details.no_days }}
                            {{ $t("Nights") }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <h2 class="text-h6 font-weight-medium py-5">
                    {{ $t("Paymentdetails") }}
                  </h2>
                  <v-row>
                    <v-col cols="12">
                      <v-sheet class="text-center pa-5" color="grey lighten-4">
                        <v-simple-table class="pa-3 grey lighten-4">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left"></th>
                                <th class="text-left">
                                  {{ $t("BookingAmount") }}
                                </th>
                                <th class="text-left">{{ $t("Fees") }}</th>
                                <th class="text-left">{{ $t("PaymentId") }}</th>
                                <th class="text-left">
                                  {{ $t("PaymentDue") }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, i) in list.payments" :key="i">
                                <td class="text-left">
                                  {{ $t(item.payment_type) }}
                                </td>
                                <td class="text-left">
                                  {{
                                    currencyConversion(
                                      item.amount,
                                      item.currency_code
                                    )
                                  }}
                                </td>
                                <td class="text-left">
                                  {{ calculateNomadCleaningFee(item) }}
                                </td>
                                <td class="text-left">
                                  {{ item.payment_id }}
                                  <v-btn
                                    small
                                    v-if="
                                      item.payment_status == 'Unpaid' &&
                                        list.booking_status === 'bs1'
                                    "
                                    :to="{
                                      name: 'CollectPayment',
                                      params: { id: list._id }
                                    }"
                                    color="light-blue white--text"
                                    >{{ $t("PayNow") }}
                                  </v-btn>
                                </td>
                                <td class="text-left">
                                  <p
                                    class="caption mt-1"
                                    v-if="item.payment_status == 'Unpaid'"
                                  >
                                    {{ formatDate(item.dateDue) }}
                                  </p>
                                  <p v-else>
                                    {{ item.payment_status }}
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  colspan="4"
                                  class="text-right font-weight-bold"
                                >
                                  {{ $t("s1655240471") }}
                                </td>
                                <td class="text-left font-weight-bold">
                                  {{ calculateTotalAmount(list.payments) }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  colspan="4"
                                  class="text-right font-weight-bold"
                                >
                                  {{ $t("s1655240821") }}
                                </td>
                                <td class="text-left font-weight-bold">
                                  {{ calculateTotalPaidAmount(list.payments) }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  colspan="4"
                                  class="text-right red--text font-weight-bold"
                                >
                                  {{ $t("s1655240866") }}
                                </td>
                                <td
                                  class="text-left font-weight-bold red--text"
                                >
                                  {{
                                    calculateTotalUnpaidAmount(list.payments)
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-sheet>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-5">
                      <l-map
                        :zoom="15"
                        :center="[
                          list.property_id.position[1],
                          list.property_id.position[0]
                        ]"
                        style="width: 100%; height: 400px"
                      >
                        <l-tile-layer :url="url" :attribution="attribution" />
                        <l-marker
                          :lat-lng="[
                            list.property_id.position[1],
                            list.property_id.position[0]
                          ]"
                        >
                        </l-marker>
                      </l-map>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" v-if="list.property_id.property_route">
                      <h2 class="text-h6 font-weight-medium pb-3 pt-5">
                        {{ $t("HowToGetThere") }}
                      </h2>
                      <p v-html="list.property_id.property_route">
                        {{ list.property_id.property_route }}
                      </p>
                    </v-col>
                    <v-col cols="6" v-if="list.property_id.rules">
                      <h2 class="text-h6 font-weight-medium pb-3 pt-5">
                        {{ $t("Houserules") }}
                      </h2>
                      <div
                        v-if="list.age_restriction"
                        class="overline text-left grey--text"
                      >
                        {{ $t(`s1655921125`) }}
                        <span>
                          <v-chip
                            class="mr-1 mb-1"
                            small
                            dark
                            color="light-blue"
                          >
                            {{ list.age_restriction }}
                          </v-chip>
                        </span>
                      </div>
                      <p
                        class="mb-0 pt-2 subtitle-2"
                        v-for="(field, i) in list.property_id.rules"
                        :key="i"
                      >
                        {{ $t(field) }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row v-if="basic_amenities.length">
                    <v-col>
                      <h2 class="text-h6 font-weight-medium text-left">
                        {{ $t("Basicamenities") }}
                      </h2>
                      <v-row>
                        <v-col
                          cols="2"
                          v-for="(item, i) in basic_amenities"
                          :key="i"
                        >
                          <h3 class="overline text-left grey--text">
                            {{ $t(item.title) }}
                          </h3>
                          <v-divider></v-divider>
                          <p
                            class="subtitle-2 mb-0 mt-2"
                            v-for="field in item.data"
                            :key="field._id"
                          >
                            {{ $t(field.ln_key) }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
              <AboutPropertyComponent
                v-if="
                  (list.booking_status == 'bs6' ||
                    list.booking_status == 'bs7') &&
                    review == 0
                "
                :data="{
                  booking_id: parm,
                  property_id: list.property_id._id,
                  rating: [1, 1, 1, 1, 1, 1]
                }"
              />
            </div>
          </div>
        </v-container>
      </div>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import timeoutMixin from "@/mixins/timeoutMixin.js";
import priceMixin from "@/mixins/priceMixin.js";
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import AboutPropertyComponent from "@/components/feedback/AboutPropertyComponent.vue";
import CancellationDetailsComponent from "@/components/booking/CancellationDetailsComponent.vue";
import AuthService from "@/services/AuthService";
import BookingService from "@/services/BookingService";
import { format } from "date-fns";

export default {
  name: "ViewBooking",
  mixins: [timeoutMixin, priceMixin],
  components: {
    FullHeaderComponent,
    CopyrightComponent,
    AboutPropertyComponent,
    CancellationDetailsComponent
  },
  data() {
    return {
      format,
      loading: true,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      list: [],
      user: {},
      parm: this.$route.params.id,
      error: null,
      dialog: false,
      basic_amenities: [],
      review: 0
    };
  },
  computed: {
    computedClass() {
      let className = "";
      if (this.list.payment_status == "Approved") {
        className = "light-green white--text";
      } else if (this.list.payment_status == "Pending") {
        className = "red darken-1 white--text";
      }
      return className;
    }
  },
  created: function() {
    BookingService.viewBooking({
      id: this.parm
    })
      .then(async result => {
        this.user = result.data.user;
        this.review = result.data.review;
        const resultList = await result.data.list;
        let {
          property_id: { pictures }
        } = resultList;
        pictures && pictures.sort((a, b) => a.order - b.order);
        this.list = { ...resultList, pictures };

        const amenities = this.list.property_id.amenities.reduce((r, a) => {
          const value = a["tag"];
          r[value] = (r[value] || []).concat(a);
          return r;
        }, {});
        this.basic_amenities = Object.entries(amenities).map(
          ([title, data]) => ({
            title,
            data
          })
        );
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    formatDate(val) {
      return this.format(new Date(val), "eee, do MMM, yyyy");
    },
    sendMessage() {
      AuthService.addMessageTopic({
        topic: "Trip to " + this.list.property_id.name
      })
        .then(result => {
          this.$router.push({
            name: "MessageViewComponent",
            params: { id: result.data.topic._id }
          });
        })
        .catch(err => {
          this.error = err.response.data.error;
        });
    }
  }
};
</script>

<style></style>
